/** Shared domain enums for normalized overview API surfaces. */

export enum OverviewContext {
  Branch = "branch",
  Parish = "parish",
  /**
   * The whole workspace: every active branch AND the parish/system branch, consolidated.
   *
   * Unlike the other two this resolves to a SET of branches rather than one, so summing is only meaningful
   * under Invariant Q (one currency per workspace) — the aggregation asserts that before it totals anything.
   * Multi-branch workspaces only: where the single branch IS the workspace, a consolidated view is the same
   * view twice.
   */
  Global = "global",
}

export enum OverviewGranularity {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
}

export enum OverviewSurface {
  Dashboard = "dashboard",
  Full = "full",
}

export enum OverviewValueFormat {
  Number = "number",
  Money = "money",
  Percentage = "percentage",
  Date = "date",
  Text = "text",
}

export enum OverviewChartType {
  Line = "line",
  Bar = "bar",
  HorizontalBar = "horizontal_bar",
  Donut = "donut",
}

export enum OverviewTableColumnType {
  Text = "text",
  Number = "number",
  Money = "money",
  /**
   * A share of the column's total, already in percent (0–100) and rounded server-side.
   *
   * What a Money column becomes when branch autonomy withholds the absolutes (ADR-0024): the row keeps its
   * place and its meaning, and only the scale is removed. Rounded on the server for the same reason the
   * donut's `shares` are — percentages derived in the browser drift, and drift in a figure that stands in
   * for money is indistinguishable from a wrong number.
   */
  Percentage = "percentage",
  Date = "date",
  Badge = "badge",
}

export enum OverviewAlertSeverity {
  Info = "info",
  Warning = "warning",
  Danger = "danger",
  Success = "success",
}

export enum OverviewVisibilityScope {
  BranchOnly = "branch_only",
  ParishOnly = "parish_only",
  Both = "both",
}

export enum OverviewModule {
  Finance = "finance",
  Members = "members",
  Activities = "activities",
  Assets = "assets",
  Workspace = "workspace",
  Dashboard = "dashboard",
}
